import { CREDITS_PER_UNIT } from '@wegic/price-ui';

/** 最多允许购买的积分总量（300 积分上限） */
export const REMIX_MAX_CREDITS = 300;

/** 计数器最少档位 */
export const REMIX_MIN_PACKS = 1;

/** 计数器最多档位（300/100=3） */
export const REMIX_MAX_PACKS = REMIX_MAX_CREDITS / CREDITS_PER_UNIT;

/** 后端 AssetRespCode.CREDIT_PURCHASE_LIMIT_EXCEEDED：累计 + 本单 > 300 时返回 */
export const CREDIT_PURCHASE_LIMIT_EXCEEDED_CODE = 810028;
